var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-1",attrs:{"icon":"","loading":_vm.loading},on:{"click":function($event){return _vm.defaultBank()}}},[_c('v-icon',{staticClass:"fa fa-certificate",attrs:{"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }